import { render, staticRenderFns } from "./MenuBody.vue?vue&type=template&id=9a2fa5bc&scoped=true&"
import script from "./MenuBody.vue?vue&type=script&lang=ts&"
export * from "./MenuBody.vue?vue&type=script&lang=ts&"
import style0 from "./MenuBody.vue?vue&type=style&index=0&id=9a2fa5bc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a2fa5bc",
  null
  
)

export default component.exports